import { render, staticRenderFns } from "./TransferSearchForm.vue?vue&type=template&id=0877f4d5&scoped=true"
import script from "./TransferSearchForm.vue?vue&type=script&lang=js"
export * from "./TransferSearchForm.vue?vue&type=script&lang=js"
import style0 from "./TransferSearchForm.vue?vue&type=style&index=0&id=0877f4d5&prod&lang=scss&scoped=true"
import style1 from "./TransferSearchForm.vue?vue&type=style&index=1&id=0877f4d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877f4d5",
  null
  
)

export default component.exports